import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["field", "submit"]

  connect() {
    // Add form submit listener
    this.element.addEventListener("submit", this.validateForm.bind(this))
  }

  disconnect() {
    // Clean up event listener
    this.element.removeEventListener("submit", this.validateForm.bind(this))
  }

  validateForm(event) {
    // Check if all required fields are filled
    const emptyFields = this.fieldTargets.filter(field => {
      return field.required && !field.value.trim()
    })

    if (emptyFields.length > 0) {
      event.preventDefault()
      
      // Add shake animation and red border to empty fields
      emptyFields.forEach(field => {
        field.classList.add("border-destructive", "animate-shake")
        
        // Remove animation class after it completes
        setTimeout(() => {
          field.classList.remove("animate-shake")
        }, 500)
        
        // Add input listener to remove error state when user types
        field.addEventListener("input", () => {
          if (field.value.trim()) {
            field.classList.remove("border-destructive")
          }
        }, { once: true })
      })

      // Focus the first empty field
      emptyFields[0].focus()
    }
  }
}
